/**
 * Converts a Google Drive sharing/viewing link into a direct thumbnail URL —
 * the only reliable way to show a Drive-hosted image in an <img> tag without
 * the viewer's Google session getting in the way. Ported from v1.
 *
 * https://drive.google.com/file/d/1MqeN.../view?usp=sharing
 *   → https://drive.google.com/thumbnail?id=1MqeN...&sz=w500#.jpg
 *
 * Non-Drive URLs pass through untouched, so this is safe to call on anything.
 */
export function driveThumbnailUrl(url: string | undefined | null, size = 'w500'): string {
  if (!url) return '';

  if (url.includes('drive.google.com')) {
    // Already a thumbnail URL — just normalise the size parameter.
    if (url.includes('drive.google.com/thumbnail')) {
      if (/[?&]sz=/.test(url)) {
        return url.replace(/([?&]sz=)[^&#]*/, `$1${size}`) + '#.jpg';
      }
      return `${url}&sz=${size}#.jpg`;
    }

    const fileMatch = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (fileMatch?.[1]) {
      return `https://drive.google.com/thumbnail?id=${fileMatch[1]}&sz=${size}#.jpg`;
    }

    const idMatch = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (idMatch?.[1]) {
      return `https://drive.google.com/thumbnail?id=${idMatch[1]}&sz=${size}#.jpg`;
    }
  }

  return url;
}
